import { AsyncReturnType } from "type-fest";

import { ConversationService } from "@/services/conversation-service";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof ConversationService.markRead>[0];
type Data = AsyncReturnType<typeof ConversationService.markRead>;
type Error = unknown;

export const useMarkRead = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    ConversationService.markRead,
    options
  );

  return result;
};
